/**
 * 我的接口
 */
import API from "../apis";
import request from "../request";
import requestJson from "../requestJson";

// 修改用户基本信息 - 个人中心
export async function userEditUserInfoApi(data) {
  return requestJson({
    url: API.userEditUserInfo,
    method: "POST",
    data,
  }).catch((e) => e);
}

// 修改密码 - 个人中心 (json)
export async function userUpdatePasswordApi(data) {
  return requestJson({
    url: API.userUpdatePassword,
    method: "POST",
    data,
  }).catch((e) => e);
}

// 用户基本信息 - 个人中心
export async function userInfoApi(data) {
  return requestJson({
    url: API.userInfo,
    method: "POST",
    data,
  }).catch((e) => e);
}

// 分期列表 - 个人中心
export async function userStageListApi(data) {
  return request({
    url: API.userStageList,
    method: "POST",
    data,
  }).catch((e) => e);
}

// 结业证书 - 个人中心
export async function userGraduationApi(data) {
  return request({
    url: API.userGraduation,
    method: "POST",
    data,
  }).catch((e) => e);
}

// 排行榜 - 个人中心
export async function userRankingApi(data) {
  return request({
    url: API.userRanking,
    method: "POST",
    data,
  }).catch((e) => e);
}

// 成绩单 - 个人中心
export async function userStageReportApi(data) {
  return request({
    url: API.userStageReport,
    method: "POST",
    data,
  }).catch((e) => e);
}

// 学习情况 - 个人中心
export async function userStudyInfoApi(data) {
  return request({
    url: API.userStudyInfo,
    method: "POST",
    data,
  }).catch((e) => e);
}

// 学习时长统计 - 个人中心
export async function userStudyTimeApi(data) {
  return request({
    url: API.userStudyTime,
    method: "POST",
    data,
  }).catch((e) => e);
}

// 我的错題 - 个人中心
export async function userWrongQuestionsApi(data) {
  return request({
    url: API.userWrongQuestions,
    method: "POST",
    data,
  }).catch((e) => e);
}

// 我的错題分布 - 个人中心
export async function userWrongQuestionsDistApi(data) {
  return request({
    url: API.userWrongQuestionsDist,
    method: "POST",
    data,
  }).catch((e) => e);
}

// 党员培训个人信息
export async function partyIndexUserInfoApi(data) {
  return request({
    url: API.partyIndexUserInfo,
    method: "POST",
    data,
  }).catch((e) => e);
}
